import marriage from "../images/marriage_contract.jpeg";
import image from "../images/Images Webp/edu_page_image.webp";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Timeline,
  TimelineItem,
  TimelineConnector,
  TimelineHeader,
  TimelineBody,
  Typography,
} from "@material-tailwind/react";
import React from "react";
import Footer from "./Footer";

export default function EducationPage() {
  const { t } = useTranslation();
  return (
    <div className="bg-gray-50 min-h-screen flex flex-col">
      <div className="flex flex-col items-center pt-8">
        <div className="text-center mb-12">
          <h1 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            {t('Getting Married in Tunis, Tunisia')}
          </h1>
        </div>
        <div className="w-full max-w-5xl px-4 mt-8">
          <img
            src={image}
            alt="Marriage Contract"
            className="w-full h-auto object-cover rounded-lg shadow-lg"
          />
        </div>
        <div className="w-full max-w-4xl px-4 mt-8">
          <Timeline>
            <TimelineItem>
              <TimelineConnector />
              <TimelineHeader>
                <Typography variant="h5" color="blue-gray">
                  {t("Mariage Civil")}:
                </Typography>
              </TimelineHeader>
              <TimelineBody className="pb-8">
                <Typography
                  color="gray"
                  className="font-normal text-gray-600 leading-relaxed"
                >
                  {t("Les mariages civils sont légalement contraignants et célébrés par un officier d'état civil ou un registraire autorisé dans le bureau de l'état civil. Seuls les mariages célébrés devant un officier d'état civil autorisé sont légaux et reconnus dans le pays.")}
                </Typography>
              </TimelineBody>
            </TimelineItem>

            <TimelineItem>
              <TimelineConnector />
              <TimelineHeader>
                <Typography variant="h5" color="blue-gray">
                  {t("Requirements")}:
                </Typography>
              </TimelineHeader>
              <TimelineBody className="pb-8">
                <Typography
                  color="gray"
                  className="font-normal text-gray-600 leading-relaxed"
                >
                  <ul className="list-disc list-inside space-y-2">
                    <li>
                      {t("Both spouses must meet the legal requirements for marriage, including minimum age (18 years old) or parental consent if under 18.")}
                    </li>
                    <li>{t("Consent of both spouses.")}</li>
                    <li>
                      {t("Confirmation by two witnesses that the spouses are free from any legal impediments to marriage.")}
                    </li>
                    <li>{t("Determination of a dowry for the wife.")}</li>
                  </ul>
                </Typography>
              </TimelineBody>
            </TimelineItem>
          </Timeline>
        </div>
      </div>

      <div className="flex flex-col items-center bg-gray-50 py-4">
        <div className="flex flex-wrap justify-center w-full max-w-5xl space-x-8 px-4">
          {[
            {
              title: t("Régime de Communauté de Biens"),
              description: t(
                "Les époux peuvent choisir le régime de communauté de biens entre eux au moment du mariage et à une date ultérieure. Le régime de communauté couvre les biens immobiliers obtenus après le mariage ou après la conclusion du contrat de communauté de biens."
              ),
            },
            {
              title: t("Régime de Propriété Individuelle"),
              description: t(
                "En Tunisie, la propriété individuelle est encore un concept récent dans de nombreuses régions qui utilisaient traditionnellement des systèmes de gestion collective des biens. Bien que le droit de propriété soit garanti par la Constitution, il est encadré par la loi, l'article 14. Sous le régime de propriété individuelle, chaque époux est propriétaire de ses biens personnels, contrairement au régime de communauté de biens où les acquisitions du couple sont détenues conjointement."
              ),
            },
          ].map((card, index) => (
            <div
              key={index}
              className="flex flex-col justify-between rounded-lg bg-white shadow-lg w-[90%] sm:w-[45%] h-auto p-6 mb-8"
            >
              <div>
                <h5 className="mb-4 text-2xl font-semibold leading-tight text-center text-gray-800">
                  {card.title}
                </h5>
                <div className="flex justify-center mb-4">
                  <img
                    src={marriage}
                    alt=""
                    className="aspect-[2/3] w-full h-48 object-cover shadow-lg rounded-md"
                    style={{ height: '192px' }} // Fixed height
                  />
                </div>
                <p className="mb-6 text-base text-center text-gray-600">
                  {card.description}
                </p>
              </div>
              <div className="flex justify-center pt-4 mt-auto">
                <Link
                  to="/quizz"
                  className="inline-block rounded-md bg-pink-600 px-6 py-2.5 text-sm font-medium uppercase leading-normal text-white shadow-md transition duration-150 ease-in-out hover:bg-pink-500 focus:bg-gray-400 focus:shadow-md focus:outline-none focus:ring-0 active:bg-gray-500 active:shadow-md"
                >
                  {t('Take a Quiz')}
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="flex flex-col items-center bg-gray-50 py-4">
        <div className="w-full max-w-4xl px-4">
          <Timeline>
            <TimelineItem>
              <TimelineConnector />
              <TimelineHeader>
                <Typography variant="h5" color="blue-gray">
                  {t("Documents Required:")}
                </Typography>
              </TimelineHeader>
              <TimelineBody className="pb-8">
                <Typography
                  color="gray"
                  className="font-normal text-gray-600 leading-relaxed"
                >
                  <ul className="list-disc list-inside space-y-2">
                    <li>{t("Birth certificate for each spouse")}</li>
                    <li>{t("Prenuptial medical certificate")}</li>
                    <li>{t("Photocopy of national identity card or other official document proving identity for each spouse")}</li>
                    <li>{t("Court authorization for those who have not reached the legal age")}</li>
                    <li>{t("Written consent of the guardian by authentic act if he does not attend the conclusion of the marriage, both for the man and the woman who has not reached the age of majority")}</li>
                    <li>{t("Extract of the death certificate of the husband or wife for widows and widowers, copy of the divorce judgment for divorced persons")}</li>
                    <li>{t("Administrative authorization for those who are members of the internal security forces, subject to prior authorization for marriage such as active agents, customs, and national army")}</li>
                    <li>{t("Certificate from the consulate or embassy attesting to the possibility of contracting marriage for foreigners")}</li>
                    <li>{t("Certificate of conversion to Islam for non-Muslims who wish to marry a Tunisian Muslim woman")}</li>
                    <li>{t("Presentation of the identity card for each of the two witnesses who must meet the required legal conditions")}</li>
                  </ul>
                </Typography>
              </TimelineBody>
            </TimelineItem>

            <TimelineItem>
              <TimelineHeader>
                <Typography variant="h5" color="blue-gray">
                  {t("Steps to Follow:")}
                </Typography>
              </TimelineHeader>
              <TimelineBody>
                <Typography
                  color="gray"
                  className="font-normal text-gray-600 leading-relaxed"
                >
                  <ol className="list-decimal list-inside space-y-2">
                    <li>
                      {t("Interested parties (both spouses or their representative with an official power of attorney) must:")}
                      <ul className="list-disc list-inside pl-5 space-y-1">
                        <li>
                          {t("Assist in preparing files to be submitted to the competent services of the Ministry of Social Affairs and Solidarity.")}
                        </li>
                        <li>{t("Submit a request to the civil registrar.")}</li>
                        <li>{t("Provide the required documents.")}</li>
                        <li>{t("Set a date for the conclusion of the marriage.")}</li>
                      </ul>
                    </li>
                    <li>
                      {t("The interested parties, as well as the witnesses and the civil registrar, must sign the marriage contract.")}
                    </li>
                  </ol>
                </Typography>
              </TimelineBody>
            </TimelineItem>

            <TimelineItem className="pt-4">
              <TimelineConnector />
              <TimelineHeader>
                <Typography variant="h5" color="blue-gray">
                  {t("Officials Involved:")}
                </Typography>
              </TimelineHeader>
              <TimelineBody className="pb-8">
                <Typography
                  color="gray"
                  className="font-normal text-gray-600"
                >
                  {t("Civil registrars of the municipal district.")}
                </Typography>
              </TimelineBody>
            </TimelineItem>
            <TimelineItem>
              <TimelineConnector />
              <TimelineHeader>
                <Typography variant="h5" color="blue-gray">
                  {t("Where to Submit the Application:")}
                </Typography>
              </TimelineHeader>
              <TimelineBody className="pb-8">
                <Typography
                  color="gray"
                  className="font-normal text-gray-600"
                >
                  {t("Civil registry office of the municipal district.")}
                </Typography>
              </TimelineBody>
            </TimelineItem>
            <TimelineItem>
              <TimelineConnector />
              <TimelineHeader>
                <Typography variant="h5" color="blue-gray">
                  {t("Where to Obtain the Service:")}
                </Typography>
              </TimelineHeader>
              <TimelineBody className="pb-8">
                <Typography
                  color="gray"
                  className="font-normal text-gray-600"
                >
                  {t("Civil registry office of the municipal district.")}
                </Typography>
              </TimelineBody>
            </TimelineItem>
            <TimelineItem>
              <TimelineConnector />
              <TimelineHeader>
                <Typography variant="h5" color="blue-gray">
                  {t("Processing Time:")}
                </Typography>
              </TimelineHeader>
              <TimelineBody className="pb-8">
                <Typography
                  color="gray"
                  className="font-normal text-gray-600"
                >
                  {t("From two days to one week")}
                </Typography>
              </TimelineBody>
            </TimelineItem>

            <TimelineItem>
              <TimelineConnector />
              <TimelineHeader>
                <Typography variant="h5" color="blue-gray">
                  {t("Legal References:")}
                </Typography>
              </TimelineHeader>
              <TimelineBody className="pb-8">
                <Typography
                  color="gray"
                  className="font-normal text-gray-600 leading-relaxed"
                >
                  <ul className="list-disc list-inside space-y-2">
                    <li>
                      {t("Articles 15 and 32 to 39 of Law No. 57 of 1 August 1957 regulating civil status.")}
                    </li>
                    <li>
                      {t("Decree of 13 August 1956 promulgating the code of personal status and the texts that amended it.")}
                    </li>
                    <li>
                      {t("Special statutes relating to the active bodies of the internal security forces, customs officers, military forces, and diplomatic agents.")}
                    </li>
                  </ul>
                </Typography>
              </TimelineBody>
            </TimelineItem>
          </Timeline>
        </div>
      </div>

      <Footer />
    </div>
  );
}
